import NotificationsColumn from './component'

export default NotificationsColumn
